import React from 'react'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

import { EmailVerificationForm } from './EmailVerificationForm'
import { VerifyCodeForm } from '../VerifyCodeForm'
import { PublicFormResponse } from '../../../components/PublicFormResponse'
import routePath from '../../../router/routePath'

enum EmailVerificationViewState {
  /**
   * View where user can set email to receive verification code
   * used for e.g. restoring email verification state from interrupted
   * registration flow
   */
  CONFIRM_SEND = 'confirm-send',
  /**
   * View where user can verify the code sent to their email. This view
   * looks and feels 1:1 with the registration flow. Also the completed statuses
   * are equal to the registration flow.
   */
  VERIFY_CODE = 'verify-code',
  /**
   * View where user has successfully verified the user email.
   */
  SUCCESS = 'success',
}

type EmailVerificationViewStateSteps =
  | EmailVerificationViewState.CONFIRM_SEND
  | EmailVerificationViewState.VERIFY_CODE
  | EmailVerificationViewState.SUCCESS

export const EmailVerification = () => {
  const navigate = useNavigate()
  const [state, setState] = React.useState<EmailVerificationViewStateSteps>(
    EmailVerificationViewState.CONFIRM_SEND
  )
  const [email, setEmail] = React.useState<string | null>(null)

  if (state === EmailVerificationViewState.CONFIRM_SEND) {
    return (
      <EmailVerificationForm
        onSuccess={(codeSentToEmailAddress) => {
          setEmail(codeSentToEmailAddress)
          setState(EmailVerificationViewState.VERIFY_CODE)
        }}
      />
    )
  }

  if (state === EmailVerificationViewState.VERIFY_CODE && email) {
    return (
      <VerifyCodeForm
        email={email}
        onSuccess={() => {
          setState(EmailVerificationViewState.SUCCESS)
        }}
        onCancel={() => {
          setState(EmailVerificationViewState.CONFIRM_SEND)
        }}
      />
    )
  }
  if (state === EmailVerificationViewState.SUCCESS) {
    return (
      <PublicFormResponse
        title={t('registration:registrationSucceeded')}
        status="success"
        onClick={() => {
          navigate(routePath.login)
        }}
        buttonText={t('login:submit')}
      />
    )
  }
  return null
}
